module.exports = __webpack_public_path__ + "static/image5-a1d91ccd43d1e8b4c5f1c0d9c02eab24.png";